module.exports = "/images/upload.svg?dae5645385440ac0ea8e9cdbac1f2db0";